import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class MiniBatchSparsePcaGraph  extends AbstractScatterVisualization {
}
